import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";
import { Response } from "../shared/models";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  constructor(private httpClient: HttpClient) { }

  get(endpoint: string, req: any = {}) {
    let param = new HttpParams();
    param = req;
    return this.httpClient.get(endpoint, { params: param });
  }
  post(endpoint: string, req: any) {
    let param = new HttpParams();
    param = req;
    return this.httpClient
      .post(endpoint, param)
      .pipe(catchError(this.formatErrors));
  }
  patch(endpoint: string, req: any) {
    let param = new HttpParams();
    param = req;
    return this.httpClient.patch(endpoint, param);
  }

  // generate kyc api
  generateKycToken(data: any): Observable<any> {
    const request = {
      url: "generateKycToken",
      params: data,
    };
    return this.httpClient.post<any>(request.url, request.params);
  }

  // update kyc api
  updateKyc(data: any): Observable<any> {
    const request = {
      url: "updateKycId",
      params: data,
    };
    return this.httpClient.post<any>(request.url, request.params);
  }
  // verify kyc api
  verifyKyc(data: any): Observable<any> {
    const request = {
      url: "verifyKyc",
      params: data,
    };
    return this.httpClient.post<any>(request.url, request.params);
  }

  // forgot password API
  logOut(data: any): Observable<any> {
    const request = {
      url: "logout",
      params: data,
    };
    return this.httpClient.post<any>(request.url, request.params);
  }

  postData(path: string, body: Object = {}): Observable<any> {
    return this.httpClient
      .post(`${path}`, JSON.stringify(body))
      .pipe(catchError(this.formatErrors));
  }
  postImage(path: string, body: any): Observable<any> {
    return this.httpClient
      .post(`${path}`, body)
      .pipe(catchError(this.formatErrors));
  }

  private formatErrors(error: any) {
    return throwError(() => error.error);
  }

  putData(endpoint: string, params: any): Observable<any> {
    const request = {
      url: endpoint,
      params: params,
    };
    return this.httpClient.put<any>(request.url, request.params);
  }

  updateData(endpoint: string, params: any): Observable<any> {
    const request = {
      url: endpoint,
      params: params,
    };
    return this.httpClient
      .patch<any>(request.url, request.params)
      .pipe(catchError(this.formatErrors));
  }

  getData(endpoint: string): Observable<Response> {
    const request = {
      url: endpoint,
    };
    return this.httpClient.get<Response>(request.url);
  }

  deleteData(endpoint: string, postdata: any): Observable<any> {
    const request = {
      url: endpoint,
    };
    return this.httpClient.delete<any>(request.url, { body: postdata });
  }

  byPassValidations(endpoint: string, params: any): Observable<any> {
    return this.httpClient.post<any>(endpoint, params).pipe(catchError(this.formatErrors));;
  }
}
